import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#8E30D0',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#E0255E',
        info: '#8E30D0',
        success: '#4CAF50',
        warning: '#FFC107',
      },
      dark: {
        primary: '#a78bfa',
        secondary: '#424242',
        accent: '#8b5cf6',
        error: '#E0255E',
        info: '#a78bfa',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
  icons: {
    iconfont: 'md',
  },
});
